import classNames from "classnames";
import {
  AppstoreOutlined,
  BarChartOutlined,
  StarOutlined,
} from "@ant-design/icons";
import { BriefcaseAltIcon } from "common/icons/BriefcaseAltIcon";
import { FileUploadAltIcon } from "common/icons/FileUploadAltIcon";
import { BillIcon } from "common/icons/BillIcon";
import { EngagementsIcon } from "common/icons/EngagementsIcon";
import { SettingIcon } from "common/icons/SettingIcon";
import { CommissionApprovalIcon } from "common/icons/CommissionApprovalIcon";
import { FilePercentageIcon } from "common/icons/FilePercentageIcon";
import { CalenderIcon } from "common/icons/CalenderIcon";
import { ClockIcon } from "common/icons/ClockIcon";
import { FlowIcon } from "common/icons/FlowIcon";

const ICON_COMPONENTS = {
  BriefcaseAltIcon,
  FileUploadAltIcon,
  BillIcon,
  EngagementsIcon,
  SettingIcon,
  CommissionApprovalIcon,
  FilePercentageIcon,
  CalenderIcon,
  ClockIcon,
  FlowIcon,
  BarChartOutlined,
  StarOutlined,
};

export const GroupIcon = ({ icon, className }) => {
  if (!icon) {
    return <AppstoreOutlined className={className} />;
  }

  if (icon.startsWith("icon-")) {
    return <i className={classNames(icon, className)} />;
  }

  const Icon = ICON_COMPONENTS[icon];
  return Icon ? (
    <Icon className={className} />
  ) : (
    <AppstoreOutlined className={className} />
  );
};
